export const REDIRECT_ERROR_KEY = 'redirectKey'
export const PARAM_ERROR_KEY = 'error'
export const REDIRECT_URI_KEY = 'redirectUri'

export const SESSION_STORAGE_KEYS = {
  ALERT_PARAMS: 'alertParams'
}
